export { default } from './Random';